<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">kegiatan</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                    <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">

                            <div class="col-md-4">
                                <span class="huruf_input">Urusan Pemerintahan</span>
                                <select @change="getDataBidang()" class="form-control show-tick" v-model="urusan_pemerintahan_id">
                                    <option value="" >-- Urusan Pemerintahan --</option>
                                    <option v-for="data in list_urusan" :key="data.urusan_pemerintahan_id" :value="data.urusan_pemerintahan_id">[{{data.kode_urusan}}] {{data.nama_urusan}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Bidang Urusan</span>
                                <select @change="getDataProgram()" class="form-control show-tick" v-model="bidang_urusan_pemerintahan_id">
                                    <option value="" >-- Bidang Urusan --</option>
                                    <option v-for="data in list_bidang" :key="data.bidang_urusan_pemerintahan_id" :value="data.bidang_urusan_pemerintahan_id">[{{data.kode_bidang}}] {{data.nama_bidang}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Program</span>
                                <select @change="cari_data()" class="form-control show-tick" v-model="program_id">
                                    <option value="" >-- Pilih Program --</option>
                                    <option v-for="data in list_program" :key="data.program_id" :value="data.program_id">[{{data.program_kode}}] {{data.program_nama}}</option>
                                </select>
                            </div>

                        </div>
                    <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th style="width: 5%">No.</th>
                            <th style="width: 15%">Kode</th>
                            <th style="width: 65%">kegiatan</th>
                            <th style="width: 15%">Pilihan</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.kegiatan_id">
                              <td class="text-center">{{index+1}}</td>
                              <td  class="text-center">{{data.kode}}</td>
                              <td>{{data.kegiatan_nama}}</td>
                              <td class="text-center" >

                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp;
                                <button @click="removeData(data.kegiatan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>
                              </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop = 'static'>
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                                <form @submit.prevent="addData()">

                                    <div class="modal-body">
                                        <div v-if="!check_data_add" class="alert alert-info text-center">
                                            <strong>SILAHKAN PILIH URUSAN, BIDANG DAN PROGRAM URUSAN TERLEBIH DAHULU!</strong> 
                                        </div>

                                        <div v-if="check_data_add">

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Kode Kegiatan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input type="number" class="form-control" placeholder="Kode Kegiatan" v-model="kegiatan_kode">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Nama Kegiatan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input type="text" class="form-control" placeholder="Kode Kegiatan" v-model="kegiatan_nama">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           

                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop = 'static'>
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                                <label for="kode">Kode Kegiatan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input type="number" class="form-control" placeholder="Kode Kegiatan" v-model="kegiatan_kode">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Nama Kegiatan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input type="text" class="form-control" placeholder="Kode Kegiatan" v-model="kegiatan_nama">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                </div>
                                <div class="modal-footer">
                                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>

<script>

    const ADD_URL = URL_APP+'api/v1/planning_kegiatan/';
    const ADD_URL_URUSAN = URL_APP+'api/v1/planning_urusan/';
    const ADD_URL_BIDANG = URL_APP+'api/v1/planning_bidang/';
    const ADD_URL_PROGRAM = URL_APP+'api/v1/planning_program/';
    const URL_SERVER = URL_APP;


    import Autocomplete from 'vue2-autocomplete-js'

    


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                bidang_urusan_pemerintahan_id : '',
                urusan_pemerintahan_id : '',

                kegiatan_id : '',
                program_id : '',
                kegiatan_kode : '',
                kegiatan_nama : '',

                check_data_add : false,
                list_data : [],
                list_urusan : [],
                list_bidang : [],
                list_program : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
         
            // this.getData();
            this.getDataUrusan();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify({
                        kegiatan_id : this.kegiatan_id,
                        urusan_pemerintahan_id : this.urusan_pemerintahan_id,
                        bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id,
                        program_id : this.program_id,
                        kegiatan_kode : this.kegiatan_kode,
                        kegiatan_nama : this.kegiatan_nama,

                    })
                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id,
                        urusan_pemerintahan_id : this.urusan_pemerintahan_id,
                        program_id : this.program_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                  console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        kegiatan_id : this.kegiatan_id,
                        urusan_pemerintahan_id : this.urusan_pemerintahan_id,
                        bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id,
                        program_id : this.program_id,
                        kegiatan_kode : this.kegiatan_kode,
                        kegiatan_nama : this.kegiatan_nama,
                    })
                }).then((res_data) => {
                //   console.log(res_data);
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                
                this.bidang_urusan_pemerintahan_id = data.bidang_urusan_pemerintahan_id;
                this.urusan_pemerintahan_id = data.urusan_pemerintahan_id;
                this.kegiatan_id = data.kegiatan_id;
                this.program_id = data.program_id;
                this.kegiatan_kode = data.kegiatan_kode;
                this.kegiatan_nama = data.kegiatan_nama;

                this.getDataUrusan();
                this.getDataBidang();
                this.getDataProgram();

            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                // this.list_program = [];

            },

        //TAMBAHAN
            getDataUrusan : function(){
                fetch(ADD_URL_URUSAN, {
                    method : 'GET',
                    headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    }
                }).then((res) => res.json()).then((res_data) => {
                    this.list_urusan = res_data;
                    this.getData();
                })
            },
            getDataBidang : function(){
                if (this.urusan_pemerintahan_id == '') {
                    this.bidang_urusan_pemerintahan_id = '';
                    this.program_id = '';
                }
                fetch(ADD_URL_BIDANG, {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    urusan_pemerintahan_id : this.urusan_pemerintahan_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                        this.list_bidang = res_data;
                        // console.log(res_data);
                        this.getData();
                })
            },
            getDataProgram : function(){
                if (this.bidang_urusan_pemerintahan_id == '') {
                    this.program_id = '';
                }
                this.check_data_add = true;
                fetch(ADD_URL_PROGRAM, {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                        this.list_program = res_data;
                        // console.log(res_data);
                        this.getData();
                })

            },
            btn_check_data_add : function(){
                if (this.urusan_pemerintahan_id == '' && this.bidang_urusan_pemerintahan_id == '' && this.program_id == '') {
                    this.check_data_add = false;
                }
            } ,
        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;

                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                if (this.program_id == '') {
                    this.check_data_add = false;
                }else{
                    this.check_data_add = true;
                }
            } 
        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
